import chooseNextProperId from 'helpers/chooseNextProperId'
import defaults from 'helpers/networkClosets/defaults'

export default function addNetworkCloset(state, action) {
  const { location } = action
  const { entities: { networkClosets: { allIds } } } = state
  const id = chooseNextProperId(allIds)

  const networkCloset = Object.assign({}, defaults, {
    name: `Network Closet ${id}`,
    location,
    id
  })

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      networkClosets: {
        byId: {
          ...state.entities.networkClosets.byId,
          [id]: networkCloset
        },
        allIds: allIds.concat(id)
      }
    },
    currentEntity: {
      type: 'networkCloset',
      id
    },
    ui: {
      ...state.ui,
      sidebarView: 'networkClosetDetails'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addNetworkCloset.js